import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'gatsby';
import Headroom from 'react-headroom';
import { AnchorLink } from "gatsby-plugin-anchor-links";

const Header = () => {
  const [mainMenuOpen, setmainMenuOpen] = useState(false);

  const mainMenuOpenToggle = useCallback(() => {
    setmainMenuOpen((state) => !state);
  }, []);

  const mainMenuClose = useCallback(() => {
    setmainMenuOpen(() => false);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mainMenuOpen ? 'hidden' : 'visible';
  }, [mainMenuOpen]);

  // useEffect(() => {
  //   // e.preventDefault();
  //   // e.stopPropagation();

  //   //const target = e.target.closest('a');
  //   const { hash } = window.location;
  //   mainMenuClose();

  //   if (hash) {
  //     window.scrollTo({
  //       top: document.querySelector(hash).offsetTop - 100,
  //       behavior: 'smooth',
  //     });
  //   }
  // }, []);

  return (
    <nav className="header">
      <Headroom disableInlineStyles>
        <div className="container  ">
          <div
            className={`nav-block flex-row col ${
              mainMenuOpen ? 'hamburger-cross' : ''
            }`}>
            <Link to="/" onClick={mainMenuClose} className="cliphire-logo">
              <img src="/img/cliphire-logo.svg" alt="" />
            </Link>
            <div
              className={`menu flex-row no-margin ${
                mainMenuOpen ? 'menu-open' : ''
              }`}>
              <div className="left-nav flex-row align-items-center">
                <div>
                  <AnchorLink to="/#how-it-works" title="How it works" onAnchorLinkClick={mainMenuClose} />
                </div>
                <div>
                  <AnchorLink to="/#cliphire-features" title="Features" onAnchorLinkClick={mainMenuClose} />
                </div>
                <div>
                  <Link to="/jobs/" onClick={mainMenuClose}>
                    Jobs
                  </Link>
                </div>
                <div>
                  <Link to="/blog/" onClick={mainMenuClose}>
                    Blog
                  </Link>
                </div>
              </div>
              <div className="right-nav">
                <Link to="/" className="log-in button ">
                  <span>Log In</span>
                </Link>
                <Link to="/" className="sign-up button ">
                  Sign up
                </Link>
              </div>
            </div>
            <button
              type="button"
              onClick={mainMenuOpenToggle}
              className="visible-mobile hamburger">
              <span />
            </button>
          </div>
        </div>
      </Headroom>
    </nav>
  );
};

export default Header;
